import { FormInput, Modal, ModalSizeEnum, PrimaryButton, SecondaryButton } from '@systemeio/ui'
import { FormEvent, useEffect, useState } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { defaultErrors, defaultHeaderValues } from './constants/default-values'
import { useEditHandler } from './hooks/use-edit-handler'
import { AddIcon } from '@systemeio/ui/icons'

export const AddHeaderModal = ({
  id,
  initialText,
  opened,
  setOpened,
}: {
  id?: number
  initialText?: string
  opened: boolean
  setOpened: (_: boolean) => void
}) => {
  const { t } = useLocoTranslation()
  const initialTextData = initialText || defaultHeaderValues.text
  const [text, setText] = useState(initialTextData)
  const { errors, isFetching, handleEdit, setErrors } = useEditHandler()

  const isEdit = id !== undefined
  const title = isEdit
    ? t('dashboard.store.edit_section.title')
    : t('dashboard.store.add_section.title')
  const buttonTitle = isEdit
    ? t('dashboard.store.edit_section.button_title')
    : t('dashboard.store.add_section.button_title')

  //if it is an edit mode, we update text to the most actual one
  useEffect(() => {
    if (isEdit && initialText) {
      setText(initialText)
    }
  }, [initialText, isEdit])

  const close = () => {
    setOpened(false)
  }

  const afterLeave = () => {
    setErrors(defaultErrors)
    setText(initialTextData)
  }

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault()
    try {
      await handleEdit({ data: { text }, id })
      close()
    } catch {}
  }

  return (
    <Modal
      title={title}
      opened={opened}
      onClose={close}
      size={ModalSizeEnum.small}
      isCentered
      isFetching={isFetching}
      afterLeave={afterLeave}
    >
      <form className="flex flex-col items-center gap-8" onSubmit={onSubmit}>
        <FormInput
          autoFocus
          className="w-full"
          key="header"
          label={t('dashboard.store.header.label')}
          value={text}
          onChange={e => setText(e.target.value)}
          error={errors.text}
        />

        <PrimaryButton type="submit" isFetching={isFetching}>
          {buttonTitle}
        </PrimaryButton>
      </form>
    </Modal>
  )
}

const AddHeader = () => {
  const { t } = useLocoTranslation()
  const [opened, setOpened] = useState(false)

  return (
    <>
      <SecondaryButton onClick={() => setOpened(true)}>
        <AddIcon className="group-focus-visible:fill-background-secondary group-hover:fill-background-secondary main-transition-colors fill-text-primary" />
        <b>{t('dashboard.store.add_section.button_title')}</b>
      </SecondaryButton>

      <AddHeaderModal opened={opened} setOpened={setOpened} />
    </>
  )
}

export default AddHeader
